<template>
  <aside :class="['slide-in', { 'slide-in--is-active': activeSlideIn }]">
    <button
      ref="closeButton"
      :aria-label="tStatic('closeSlideIn')"
      class="slide-in__close-action"
      @click="handleClose">
      <oie-base-icon icon="close"></oie-base-icon>
    </button>

    <portal-target name="slide-in-content" slim></portal-target>
  </aside>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('ui', ['activeSlideIn'])
  },
  watch: {
    activeSlideIn(newVal) {
      if(newVal) {
        this.$refs.closeButton.focus()
      }
    }
  },
  methods: {
    ...mapActions('ui', ['setActiveSlideIn']),
    handleClose() {
      this.publish('generic-slide-in-close')
      this.setActiveSlideIn(null)
    }
  }
}
</script>

<style lang="scss">
.slide-in {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 30rem;
  z-index: 102;
  overflow: hidden;
  transform: translateX(100%);

  @media (prefers-reduced-motion: no-preference) {
    transition: transform 220ms cubic-bezier(0,0,.2,1);
  }
}

.slide-in--is-active {
  transform: translateX(0);
}

.slide-in__close-action {
  @include reset-button;
  position: absolute;
  top: measure(eighth);
  right: measure(eighth);
  width: 3rem;
  height: 3rem;
  padding: measure(eighth);
  color: black;

  @media (prefers-reduced-motion: no-preference) {
    transition: transform 140ms;
  }
}
</style>
